<template>
  <v-row justify="center" class="joinform-page">
    <v-card
      width="100%"
      class="text-xs-center mt-8 elevation-12"
      max-width="800px"
    >
      <v-row justify="center" class="ma-0">
        <v-col class="px-8 py-0 text-left joinform-title">
          {{ $t('회원가입') }}
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-10 mt-6">
        <v-col cols="12" class="col-md-6 pl-8 pr-4 py-0">
          <v-form ref="form">
            <i-text-field
              v-model="name"
              :prepend-inner-icon="mdiAccount"
              :rules="[rules.required, rules.noSpecialChar]"
              label="이름을 입력해주세요."
              required
              outlined
              dense
            ></i-text-field>
            <div class="overlap-wrap">
              <i-text-field
                ref="email"
                v-model="email"
                :prepend-inner-icon="mdiEmail"
                :error-messages="emailErrors"
                label="이메일을 입력해주세요."
                :rules="[rules.required]"
                required
                :readonly="emailCheckType == 'V' || emailCheckType == 'S'"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
                outlined
                dense
              ></i-text-field>
              <i-btn
                v-if="emailCheckType == 'C' || emailCheckType == 'D'"
                rounded
                outlined
                small
                color="primary"
                class="overlap-confirm"
                @click="emailCheck"
                >중복확인</i-btn
              >
              <i-btn
                v-if="emailCheckType == 'V'"
                rounded
                outlined
                small
                color="primary"
                class="overlap-confirm"
                @click="sendEmailCode"
                >인증코드발송</i-btn
              >
              <i-btn
                v-if="emailCheckType == 'S'"
                rounded
                outlined
                small
                color="primary"
                class="overlap-confirm btn-resend"
                @click="sendEmailCode"
                >인증코드재발송</i-btn
              >
            </div>
            <div class="overlap-wrap">
              <i-text-field
                v-model="emailCode"
                :prepend-inner-icon="mdiCodeArray"
                :rules="[rules.required]"
                label="이메일 인증코드 입력해주세요."
                required
                outlined
                dense
              ></i-text-field>
              <span class="timer overlap-confirm">
                <div id="timer">
                  <span class="time">{{ timerActive ? timerMsg : '' }}</span
                  ><span v-if="timerMsg == 'timeout'" class="over"
                    >인증시간초과</span
                  >
                </div>
              </span>
            </div>
            <div class="overlap-wrap">
              <i-text-field
                ref="phone"
                v-model="phone"
                :prepend-inner-icon="mdiPhone"
                :rules="[rules.required, rules.phone]"
                required
                label="핸드폰번호를 입력해주세요"
                class="input-group--focused"
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
                outlined
                dense
              >
              </i-text-field>
            </div>
            <i-text-field
              v-model="password"
              :prepend-inner-icon="mdiKey"
              :append-icon="show1 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
              ]"
              :type="show1 ? 'text' : 'password'"
              label="비밀번호를 입력해주세요"
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show1 = !show1"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              outlined
              dense
            ></i-text-field>
            <i-text-field
              v-model="passwordCheck"
              :prepend-inner-icon="mdiKey"
              :append-icon="show2 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
                rules.passwordMatch,
              ]"
              :type="show2 ? 'text' : 'password'"
              label="비밀번호를 확인해주세요"
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show2 = !show2"
              @input="$v.passwordCheck.$touch()"
              @blur="$v.passwordCheck.$touch()"
              outlined
              dense
            ></i-text-field>
            <v-subheader class="text-left info-msg">{{
              $t(
                '비밀번호는 8~16자의 영문 대소문자, 숫자 및 특수문자를 사용해주시기바랍니다.',
              )
            }}</v-subheader>
          </v-form>
        </v-col>
        <v-col cols="12" class="col-md-6 text-center pl-4 pr-8 py-0">
          <template>
            <v-container fluid class="py-0 right-container">
              <ckeditor
                class="terms"
                style="height: 360px"
                :editor="editor"
                :config="editorConfig"
                @ready="editorInit"
                v-model="personalPolicy.privacyPolicy"
              ></ckeditor>
              <!--
              <div
                class="terms"
                v-html="personalPolicy.privacyPolicy"
                style="height: 360px"
              ></div>
              -->
              <i-checkbox
                v-model="checkbox1"
                label="개인정보 수집 및 이용에 대한 동의"
              ></i-checkbox>
            </v-container>
          </template>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="space-between" class="ma-0 px-6 py-4">
        <i-btn text color="#777e87" class="" @click="goLoginPage">로그인</i-btn>
        <i-btn color="primary" class="" @click="signup">회원가입</i-btn>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

import { getEncryption, postJson } from '@/api/network';
import { getJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

import DecoupledDocument from '@ckeditor/ckeditor5-build-decoupled-document';
import Base64Upload from '@/plugins/ckeditor5/base64Upload/Base64Upload';

import RSAKey from '@/utils/rsa/rsa.js';

import {
  mdiAccount,
  mdiEmail,
  mdiCodeArray,
  mdiKey,
  mdiEye,
  mdiEyeOff,
  mdiPhone,
} from '@mdi/js';

export default {
  components: {},
  mixins: [validationMixin, DialogMixin, LoadingMixin],
  validations: {
    email: { required, email },
    phone: { required },
    password: { required },
    passwordCheck: { required },
  },
  props: {
    routeParam: Object,
  },
  data() {
    return {
      mdiAccount,
      mdiPhone,
      mdiEmail,
      mdiCodeArray,
      mdiKey,
      mdiEye,
      mdiEyeOff,
      timer: '',
      timerActive: false,
      setTime: 180,
      timerMsg: '',
      name: '',
      email: '',
      emailCode: '',
      phone: '',
      password: '',
      passwordCheck: '',
      logMessage: '',
      invalid: false,
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || '필수입력 사항입니다.',
        min: v => v.length >= 8 || '최소 8자 이상 입력하셔야합니다.',
        char: v =>
          /(?=.*[a-zA-Z])/.test(v) || '최소 하나의 영문자가 필요합니다.',
        number: v => /(?=.*\d)/.test(v) || '최소 하나의 숫자가 필요합니다.',
        noSpecialChar: v =>
          !/([!@#$%])/.test(v) || '특수문자는 허용되지 않습니다.',
        specialChar: v =>
          /([!@#$%])/.test(v) || '최소 하나의 특수문자가 필요합니다. [!@#$%]',
        passwordMatch: value =>
          value === this.password || '비밀번호가 일치하지 않습니다.',
        phone: v =>
          /(01[016789])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v) ||
          '핸드폰 번호 형식을 다시 확인해 주세요.',
      },
      checkbox1: false,
      checkbox2: false,
      personalPolicy: {},
      sensitivePolicy: {},
      emailCheckType: 'C', // 'C': 중복확인, 'V': 유효한 이메일, 'D': 이메일 중복, 'S': 이메일 전송 'R': 삭제된 이메일
      editor: DecoupledDocument,
      editorConfig: { extraPlugins: [Base64Upload] },
    };
  },
  created() {
    this.getPolicy();
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push(this.$t('이메일 형식을 확인하세요.'));
      !this.$v.email.required && errors.push(this.$t('필수 입력사항입니다.'));
      this.emailCheckType == 'D' &&
        errors.push(this.$t('이미 가입되어 있는 이메일입니다.'));
      this.emailCheckType == 'R' &&
        errors.push(this.$t('이미 탈퇴한 계정입니다.'));
      return errors;
    },
  },
  methods: {
    editorInit(editor) {
      //READ-ONLY
      editor.isReadOnly = true;
      var element = editor.ui.view.toolbar.element;
      element.style.display = 'none';

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(element, editor.ui.getEditableElement());
    },
    initForm() {
      this.email = '';
      this.password = '';
    },
    goLoginPage() {
      this.$router.push('/login/' + this.$route.params.tenantKey);
    },
    getPolicy() {
      try {
        getJson(
          'info/' + this.$route.params.tenantKey + '/join/privacyPolicy',
          {},
        ).then(res => {
          if (res.data.hasOwnProperty('personalPolicy'))
            this.personalPolicy = res.data.personalPolicy;

          if (res.data.hasOwnProperty('sensitivePolicy'))
            this.sensitivePolicy = res.data.sensitivePolicy;
        });
      } catch (error) {
        console.log(error);
        //this.logMessage = error.response.data;
      }
    },
    async emailCheck() {
      this.emailCheckType = 'C';
      this.$v.$touch();

      if (this.$refs.email.validate() && this.emailErrors.length == 0) {
        try {
          const rsa = new RSAKey();
          const {
            publicKeyModulus,
            publicKeyExponent,
            sessionKey,
          } = await getEncryption();
          rsa.setPublic(publicKeyModulus, publicKeyExponent);
          const p = {
            email: rsa.encrypt(this.email),
            sessionKey: sessionKey,
          };
          getJson(
            'api/login/' + this.$route.params.tenantKey + '/email/check',
            p,
          )
            .then(res => {
              if (res.data && res.data.hasOwnProperty('code')) {
                //휴면계정일 경우
                if (res.data.code == 'H') {
                  this.showAlert({
                    message:
                      '해당 계정은 휴면계정입니다. 휴면해제 화면으로 이동합니다.',
                    callback: this.goDormantUserClear,
                    param: this.email,
                  });
                } else {
                  // 이메일 인증 완료
                  this.emailCheckType = res.data.code;
                }
              }
            })
            .catch(error => {
              console.log(error.response);
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
    async sendEmailCode() {
      if (this.emailCheckType == 'V' || this.emailCheckType == 'S') {
        try {
          this.showLoading();
          const rsa = new RSAKey();
          const {
            publicKeyModulus,
            publicKeyExponent,
            sessionKey,
          } = await getEncryption();
          rsa.setPublic(publicKeyModulus, publicKeyExponent);
          const p = {
            email: rsa.encrypt(this.email),
            sessionKey: sessionKey,
          };

          postJson(
            'api/login/' +
              this.$route.params.tenantKey +
              '/sendCertificateCodeForJoin',
            p,
          )
            .then(res => {
              if (res.data != null && res.data.hasOwnProperty('status')) {
                if (res.data.status == 'success') {
                  this.timerStart();
                }

                this.hideLoading();
                this.$showAlert(res.data.message);
              }

              //이메일 인증코드 전송
              this.emailCheckType = 'S';
            })
            .catch(error => {
              console.log(error.response);
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
    async signup() {
      if (this.emailErrors.length == 0 && this.$refs.form.validate()) {
        let isChk = true;

        if (!this.checkbox1) {
          isChk = false;

          this.$showAlert(
            '개인정보 수집 및 이용 약관과 민감정보 수집 및 이용에 관한 사항에 모두 동의해주세요.',
          );
        }

        if (isChk) {
          this.showLoading();
          const rsa = new RSAKey();
          const {
            publicKeyModulus,
            publicKeyExponent,
            sessionKey,
          } = await getEncryption();
          rsa.setPublic(publicKeyModulus, publicKeyExponent);
          const p = {
            email: rsa.encrypt(this.email),
            otp: rsa.encrypt(this.emailCode),
            password: rsa.encrypt(this.password),
            name: rsa.encrypt(this.name),
            phone: rsa.encrypt(this.phone),
            personalAgreeId: this.personalPolicy.privacyPolicyId,
            sensitiveAgreeId: this.sensitivePolicy.privacyPolicyId,
            sessionKey: sessionKey,
          };

          postJson(
            'api/login/' + this.$route.params.tenantKey + '/join/vue/user',
            p,
          )
            .then(res => {
              const v = {
                message: '',
                title: '',
                callback: '',
              };

              if (
                res.data != null &&
                res.data.hasOwnProperty('status') &&
                res.data.status == 'success'
              ) {
                v.message = res.data.message;
                v.callback = this.goLoginPage;
              } else {
                v.message = res.data.message;
              }
              this.hideLoading();
              this.showAlert(v);
            })
            .catch(error => {
              console.log(error.response);
            });
        }
      } else
        document
          .querySelector('.error--text')
          ?.scrollIntoView({ block: 'center' });
    },
    timerStart() {
      if (this.timerActive) this.timerStop();
      this.timer = setInterval(this.timerCount, 1000);
    },
    timerStop() {
      clearInterval(this.timer); // 타이머 해제
      this.timerActive = false;
      this.setTime = 180;
      this.timerMsg = '';
    },
    timerCount() {
      if (!this.timerActive) this.timerActive = true;

      var mm = Math.floor(this.setTime / 60);
      var ss =
        this.setTime % 60 < 10 ? '0' + (this.setTime % 60) : this.setTime % 60;
      var msg = mm + ':' + ss + '';
      this.timerMsg = msg; // div 영역에 보여줌
      this.setTime--; // 1초씩 감소
      if (this.setTime < 0) {
        // 시간종료
        clearInterval(this.timer); // 타이머 해제
        this.timerActive = false;
        this.setTime = 180;
        this.timerMsg = 'timeout';
      }
    },
    goDormantUserClear(email) {
      this.$router.push({
        name: 'dormant',
        params: { tenantKey: this.$route.params.tenantKey, email: email },
      });
    },
  },
};
</script>

<style>
/* .v-card {
  opacity: 0.8;
} */
.v-subheader.info-msg {
  align-items: baseline;
}
.overlap-wrap {
  position: relative;
}
.overlap-wrap .v-text-field input {
  width: 70%;
  max-width: 70%;
}
.overlap-confirm {
  position: absolute;
  right: 10px;
  top: 10px;
}
.timer {
  top: 18px;
  font-size: 14px;
  color: #1976d2;
}
.timer .over {
  color: red;
}
.info-msg::before {
  content: '※';
}
.v-input--selection-controls:first-child {
  margin-top: 0px;
} /* policy term */
.terms {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 10px 12px;
  border: 1px solid #ccc;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  background-color: #fff;
  color: gray;
} /* tablet */
@media all and (max-width: 768px) {
  .v-sheet {
    height: auto !important;
    box-shadow: none !important;
  }
}

/* 김대식 css 작업구간 */

.joinform-page .joinform-title {
  padding: 24px 32px !important;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #d5d8dc;
  color: #363c43;
}

.joinform-page .v-card {
  border-radius: 20px !important;
}
.joinform-page .v-input__slot {
  min-height: 38px !important;
}
.joinform-page .v-icon {
  font-size: 18px !important;
}
.joinform-page .v-label {
  font-size: 14px;
}

.joinform-page .overlap-confirm {
  /* height: 38px !important; 
  position: static; 
  color: #fff; */
  top: 3px !important;
  height: 32px !important;
  font-size: 14px !important;
  background-color: #465166 !important;
  border-radius: 4px !important;
  color: #fff !important;
}

.joinform-page .overlap-confirm.timer {
  display: flex !important;
  align-items: center !important;
  background-color: #fff !important;
  color: #363c43 !important;
}

.right-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

/* 김대식 css 작업구간 */
</style>
